import { VentasBTL } from "../../components";

const VentasBTLpage = () => <VentasBTL />;

export default VentasBTLpage;
